module.exports = __webpack_public_path__ + "img/access-facebook-ads_bg1.d430cb3c.png";